import { format, subMonths } from 'date-fns';
import { useMemo } from 'react';

import i18n, { locales } from '@/config/i18n';

import { capitalizeString } from '../utils/capitalizeString';
import { matchLanguageToLocale } from '../utils/matchLanguageToLocale';

export function buildInitialPeriod() {
  return {
    label: capitalizeString(
      format(new Date(), 'LLLL', {
        locale: matchLanguageToLocale[i18n.language] || locales.ptBR,
      }),
    ),
    value: format(new Date(), 'MMM/yyyy', {
      locale: matchLanguageToLocale[i18n.language] || locales.ptBR,
    }).toUpperCase(),
  };
}

export function useCalculatePeriods() {
  const periods = useMemo(() => {
    const options: {
      label: string;
      options: { label: string; value: string }[];
    }[] = [];

    let currentDate = new Date();

    while (currentDate >= new Date(2024, 0, 1)) {
      const year = format(currentDate, 'yyyy', {
        locale: matchLanguageToLocale[i18n.language] || locales.ptBR,
      });

      const label = capitalizeString(
        format(currentDate, 'LLLL', {
          locale: matchLanguageToLocale[i18n.language] || locales.ptBR,
        }),
      );

      const value = format(currentDate, 'MMM/yyyy', {
        locale: matchLanguageToLocale[i18n.language] || locales.ptBR,
      }).toUpperCase();

      const yearOption = options.find(option => option.label === year);

      if (yearOption) {
        yearOption.options.push({ label, value });
      } else {
        options.push({ label: year, options: [{ label, value }] });
      }

      currentDate = subMonths(currentDate, 1);
    }

    return options;
  }, []);

  return {
    periods,
  };
}
